import * as React from "react";
import { inject, observer } from "mobx-react";
import BlockEditBox from "../components/BlockEditBox/BlockEditBox";
import BlockKitStore from "../stores/BlockKitStore";
import BlockCreateBox from "../components/BlockCreateBox/BlockCreateBox";
import BlockFilterBox from "../components/BlockFilterBox/BlockFilterBox";
import LazyLoading from "../components/LazyLoading/LazyLoading";
import { Button, Container, Stack } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface IBtsPageProps {
  blockKitStore?: BlockKitStore;
}

const BtsPage: React.FC<IBtsPageProps> = inject("blockKitStore")(observer(({
  blockKitStore
}) => {
  const [isAddMode, setIsAddMode] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    blockKitStore?.initAsync();
  }, []);

  const loadingBlocks = () => {
    setIsLoading(true);
    setTimeout(async () => {
      await blockKitStore?.initSearchedBlocksAsync();
      setIsLoading(false);
    }, 1);
  }

  const onBlockListChanged = async () => {
    await blockKitStore?.initSearchedBlocksAsync();
  };

  return (
    <Container className="g-2 p-2" fluid style={{ height: "90vh", overflowY: "auto" }}>
      <Stack gap={2}>
        <Stack direction="horizontal" gap={2}>
          <Button
            onClick={() => setIsAddMode(true)}>
            {t("button-new")}
          </Button>
        </Stack>
        {isAddMode &&
          <BlockCreateBox
            isShow={isAddMode}
            onClickClose={() => setIsAddMode(false)}
          />
        }
        <BlockFilterBox
          onClickLoading={() =>
            loadingBlocks()
          }
          isLoading={isLoading}
        />
        {!isLoading &&
         blockKitStore?.blocks?.map((data) => {
            return (
              <LazyLoading key={data.data.id}>
                <BlockEditBox
                  key={data.data.id}
                  block={data.data}
                  onBlockListChanged={onBlockListChanged}
                  onClickPublish={async () => {
                    if (!confirm(t("publish-confirmation-message"))) {
                      return;
                    }

                    try {
                      if (!(await blockKitStore?.isPublishableLicenseAsync(data.data.licenseId))) {
                        alert(t("publish-license-not-published"));
                        return;
                      }
                    } catch (error: unknown) {
                      alert(`${t("license-load-failed")} (${blockKitStore?.studioController.getErrorMessage(error).message})`);
                      return;
                    }

                    const response = await blockKitStore?.studioController.publishBlockStagingAsync(data.data);
                    if (response?.isSuccess) {
                      alert(t("publish-success"));
                    } else {
                      alert(`${t("publish-failed")} (${response?.message})`);
                    }
                  }}
                />
              </LazyLoading>
            )
          })
        }
      </Stack>
    </Container>
  );
}));

export default BtsPage;
